// Central Multi-Geo Configuration for Dinosaur World Festival 2026

export const GEOS = {
  qa: {
    id: 'qa',
    name: 'Qatar',
    currencyCode: 'QAR',
    currencySymbol: { ar: 'ر.ق', en: 'QAR' },
    phonePrefix: '+974',
    phonePlaceholder: '33123456',
    seatPrefix: 'QA',
    defaultLang: 'ar',
    supportedLangs: ['ar', 'en'],
    merchantName: 'Dino World Qatar',
    domainName: 'dinoworld-qatar.com',
    venue: {
      ar: 'مركز قطر الوطني للمؤتمرات (QNCC) - القاعة 5',
      en: 'Qatar National Convention Centre (QNCC) - Hall 5'
    },
    datesText: {
      ar: 'مفتوح يومياً: 16 سبتمبر – 31 أكتوبر 2026 | تذكرة مرنة صالحة طوال الفترة (09:00 ص – 09:00 م)',
      en: 'Open Daily: 16 September – 31 October 2026 | Valid Any Day (09:00 AM – 09:00 PM)'
    },
    validUntilDate: {
      ar: '31 أكتوبر 2026',
      en: '31 October 2026'
    },
    isOpenPass: true,
    dates: {
      'any-day-pass': { arDay: 'تذكرة مفتوحة • أي يوم', enDay: 'OPEN PASS • ANY DATE', arDate: 'صالحة لأي يوم حتى 31 أكتوبر 2026', enDate: 'Valid Any Day until 31 Oct 2026', arTag: 'الأكثر طلباً • مرونة 100%', enTag: 'Best Value • 100% Flexible' },
      'weekday-pass': { arDay: 'تذكرة أيام الأسبوع (أحد - خميس)', enDay: 'WEEKDAY PASS (SUN–THU)', arDate: 'صالحة لأي يوم عمل حتى 31 أكتوبر', enDate: 'Any Weekday until 31 Oct 2026', arTag: 'أوقات هادئة', enTag: 'Calm Visit' },
      'weekend-pass': { arDay: 'تذكرة عطلة نهاية الأسبوع (جمعة - سبت)', enDay: 'WEEKEND PASS (FRI–SAT)', arDate: 'صالحة لأي عطلة نهاية أسبوع', enDate: 'Any Weekend until 31 Oct 2026', arTag: 'أجواء حماسية', enTag: 'Weekend Prime' }
    },
    defaultDate: 'any-day-pass',
    banner: {
      ar: './images/dino_world_qatar_banner_ar.jpg',
      en: './images/dino_world_qatar_banner_en.jpg'
    },
    tiersConfig: {
      vip: {
        id: 'vip',
        color: '#fbc61c',
        popular: true,
        options: {
          adult: { standardPrice: 153.00, price: 76.50 },
          kid: { standardPrice: 117.00, price: 58.50 }
        }
      }
    }
  },

  ph: {
    id: 'ph',
    name: 'Philippines',
    currencyCode: 'PHP',
    currencySymbol: { en: '₱' },
    phonePrefix: '+63',
    phonePlaceholder: '9171234567',
    seatPrefix: 'PH',
    defaultLang: 'en',
    supportedLangs: ['en'],
    merchantName: 'Dino World Philippines',
    domainName: 'dinoworld-philippines.com',
    venue: {
      en: 'SMX Convention Center Manila (Function Halls 1-4), Mall of Asia Complex, Pasay City'
    },
    datesText: {
      en: 'Open Daily: 18 September – 1 November 2026 | Valid Any Day (09:00 AM – 09:00 PM)'
    },
    validUntilDate: {
      en: '1 November 2026'
    },
    isOpenPass: true,
    dates: {
      'any-day-pass': { enDay: 'OPEN PASS • ANY DATE', enDate: 'Valid Any Day until 1 Nov 2026', enTag: 'Best Value • 100% Flexible' },
      'weekday-pass': { enDay: 'WEEKDAY PASS (MON–FRI)', enDate: 'Any Weekday until 1 Nov 2026', enTag: 'Calm Visit • Less Crowded' },
      'weekend-pass': { enDay: 'WEEKEND PASS (SAT–SUN)', enDate: 'Any Weekend until 1 Nov 2026', enTag: 'Weekend Prime' }
    },
    defaultDate: 'any-day-pass',
    banner: {
      en: './images/dino_world_philippines_banner_en.jpg'
    },
    tiersConfig: {
      vip: {
        id: 'vip',
        color: '#fbc61c',
        popular: true,
        options: {
          adult: { standardPrice: 990.00, price: 495.00 },
          kid: { standardPrice: 790.00, price: 395.00 }
        }
      }
    }
  },

  om: {
    id: 'om',
    name: 'Oman',
    currencyCode: 'OMR',
    currencySymbol: { ar: 'ر.ع.', en: 'OMR' },
    phonePrefix: '+968',
    phonePlaceholder: '91234567',
    seatPrefix: 'OM',
    defaultLang: 'ar',
    supportedLangs: ['ar', 'en'],
    merchantName: 'Dino World Oman',
    domainName: 'dinoworld-oman.com',
    venue: {
      ar: 'مركز عُمان للمؤتمرات والمعارض (OCEC) - مسقط (القاعة 3 و4)',
      en: 'Oman Convention & Exhibition Centre (OCEC) - Muscat (Halls 3 & 4)'
    },
    datesText: {
      ar: 'مفتوح يومياً: 17 سبتمبر – 31 أكتوبر 2026 | تذكرة مرنة صالحة طوال الفترة (09:00 ص – 09:00 م)',
      en: 'Open Daily: 17 September – 31 October 2026 | Valid Any Day (09:00 AM – 09:00 PM)'
    },
    validUntilDate: {
      ar: '31 أكتوبر 2026',
      en: '31 October 2026'
    },
    isOpenPass: true,
    dates: {
      'any-day-pass': { arDay: 'تذكرة مفتوحة • أي يوم', enDay: 'OPEN PASS • ANY DATE', arDate: 'صالحة لأي يوم حتى 31 أكتوبر 2026', enDate: 'Valid Any Day until 31 Oct 2026', arTag: 'الأكثر طلباً • مرونة 100%', enTag: 'Best Value • 100% Flexible' },
      'weekday-pass': { arDay: 'تذكرة أيام الأسبوع (أحد - خميس)', enDay: 'WEEKDAY PASS (SUN–THU)', arDate: 'صالحة لأي يوم عمل حتى 31 أكتوبر', enDate: 'Any Weekday until 31 Oct 2026', arTag: 'أوقات هادئة', enTag: 'Calm Visit' },
      'weekend-pass': { arDay: 'تذكرة عطلة نهاية الأسبوع (جمعة - سبت)', enDay: 'WEEKEND PASS (FRI–SAT)', arDate: 'صالحة لأي عطلة نهاية أسبوع', enDate: 'Any Weekend until 31 Oct 2026', arTag: 'أجواء حماسية', enTag: 'Weekend Prime' }
    },
    defaultDate: 'any-day-pass',
    banner: {
      ar: './images/dino_world_oman_banner_ar.jpg',
      en: './images/dino_world_oman_banner_en.jpg'
    },
    tiersConfig: {
      vip: {
        id: 'vip',
        color: '#fbc61c',
        popular: true,
        options: {
          adult: { standardPrice: 16.00, price: 8.00 },
          kid: { standardPrice: 12.00, price: 6.00 }
        }
      }
    }
  },

  kw: {
    id: 'kw',
    name: 'Kuwait',
    currencyCode: 'KWD',
    currencySymbol: { ar: 'د.ك.', en: 'KWD' },
    phonePrefix: '+965',
    phonePlaceholder: '91234567',
    seatPrefix: 'KW',
    defaultLang: 'ar',
    supportedLangs: ['ar', 'en'],
    merchantName: 'Dino World Kuwait',
    domainName: 'dinoworld-kuwait.com',
    venue: {
      ar: 'أرض المعارض الدولية (مشرف) - صالة 5 و6، الكويت',
      en: 'Kuwait International Fair (KIF Mishref) - Halls 5 & 6'
    },
    datesText: {
      ar: 'مفتوح يومياً: 17 سبتمبر – 31 أكتوبر 2026 | تذكرة مرنة صالحة طوال الفترة (09:00 ص – 09:00 م)',
      en: 'Open Daily: 17 September – 31 October 2026 | Valid Any Day (09:00 AM – 09:00 PM)'
    },
    validUntilDate: {
      ar: '31 أكتوبر 2026',
      en: '31 October 2026'
    },
    isOpenPass: true,
    dates: {
      'any-day-pass': { arDay: 'تذكرة مفتوحة • أي يوم', enDay: 'OPEN PASS • ANY DATE', arDate: 'صالحة لأي يوم حتى 31 أكتوبر 2026', enDate: 'Valid Any Day until 31 Oct 2026', arTag: 'الأكثر طلباً • مرونة 100%', enTag: 'Best Value • 100% Flexible' },
      'weekday-pass': { arDay: 'تذكرة أيام الأسبوع (أحد - خميس)', enDay: 'WEEKDAY PASS (SUN–THU)', arDate: 'صالحة لأي يوم عمل حتى 31 أكتوبر', enDate: 'Any Weekday until 31 Oct 2026', arTag: 'أوقات هادئة', enTag: 'Calm Visit' },
      'weekend-pass': { arDay: 'تذكرة عطلة نهاية الأسبوع (جمعة - سبت)', enDay: 'WEEKEND PASS (FRI–SAT)', arDate: 'صالحة لأي عطلة نهاية أسبوع', enDate: 'Any Weekend until 31 Oct 2026', arTag: 'أجواء حماسية', enTag: 'Weekend Prime' }
    },
    defaultDate: 'any-day-pass',
    banner: {
      ar: './images/dino_world_kuwait_banner_ar.jpg',
      en: './images/dino_world_kuwait_banner_en.jpg'
    },
    tiersConfig: {
      vip: {
        id: 'vip',
        color: '#fbc61c',
        popular: true,
        options: {
          adult: { standardPrice: 14.00, price: 7.00 },
          kid: { standardPrice: 10.00, price: 5.00 }
        }
      }
    }
  },

  hk: {
    id: 'hk',
    name: 'Hong Kong',
    currencyCode: 'HKD',
    currencySymbol: { zh: 'HK$', en: 'HK$' },
    phonePrefix: '+852',
    phonePlaceholder: '91234567',
    seatPrefix: 'HK',
    defaultLang: 'zh',
    supportedLangs: ['zh', 'en'],
    merchantName: 'Dino World Hong Kong',
    domainName: 'dinoworld-hongkong.com',
    venue: {
      zh: '亞洲國際博覽館 (AsiaWorld-Expo) - 2號展館',
      en: 'AsiaWorld-Expo - Hall 2, Hong Kong'
    },
    datesText: {
      zh: '每日開放：2026年9月18日 – 11月1日 | 全期有效 (09:00 – 21:00)',
      en: 'Open Daily: 18 September – 1 November 2026 | Valid Any Day (09:00 AM – 09:00 PM)'
    },
    validUntilDate: {
      zh: '2026年11月1日',
      en: '1 November 2026'
    },
    isOpenPass: true,
    dates: {
      'any-day-pass': { zhDay: '全期通用門票 (任意日期)', enDay: 'OPEN PASS • ANY DATE', zhDate: '2026年11月1日前任意單日有效', enDate: 'Valid Any Day until 1 Nov 2026', zhTag: '最受歡迎 • 100%靈活', enTag: 'Best Value • 100% Flexible' },
      'weekday-pass': { zhDay: '平日門票 (星期一至五)', enDay: 'WEEKDAY PASS (MON–FRI)', zhDate: '11月1日前任意平日有效', enDate: 'Any Weekday until 1 Nov 2026', zhTag: '舒適避峰', enTag: 'Calm Visit' },
      'weekend-pass': { zhDay: '週末門票 (星期六及日)', enDay: 'WEEKEND PASS (SAT–SUN)', zhDate: '11月1日前任意週末有效', enDate: 'Any Weekend until 1 Nov 2026', zhTag: '週末黃金場', enTag: 'Weekend Prime' }
    },
    defaultDate: 'any-day-pass',
    banner: {
      zh: './images/dino_world_hongkong_banner_zh.jpg',
      en: './images/dino_world_hongkong_banner_en.jpg'
    },
    tiersConfig: {
      vip: {
        id: 'vip',
        color: '#fbc61c',
        popular: true,
        options: {
          adult: { standardPrice: 276.00, price: 138.00 },
          kid: { standardPrice: 196.00, price: 98.00 }
        }
      }
    }
  },

  sg: {
    id: 'sg',
    name: 'Singapore',
    currencyCode: 'SGD',
    currencySymbol: { en: 'S$' },
    phonePrefix: '+65',
    phonePlaceholder: '81234567',
    seatPrefix: 'SG',
    defaultLang: 'en',
    supportedLangs: ['en'],
    merchantName: 'Dino World Singapore',
    domainName: 'sgdynoworld.live',
    venue: {
      en: 'Singapore Expo (Halls 3 & 4), 1 Expo Drive, Singapore'
    },
    datesText: {
      en: 'Open Daily: 10 September – 31 October 2026 | Valid Any Day (09:00 AM – 09:00 PM)'
    },
    validUntilDate: {
      en: '31 October 2026'
    },
    isOpenPass: true,
    dates: {
      'any-day-pass': { enDay: 'OPEN PASS • ANY DATE', enDate: 'Valid Any Day until 31 Oct 2026', enTag: 'Best Value • 100% Flexible' },
      'weekday-pass': { enDay: 'WEEKDAY PASS (MON–FRI)', enDate: 'Any Weekday until 31 Oct 2026', enTag: 'Calm Visit • Less Crowded' },
      'weekend-pass': { enDay: 'WEEKEND PASS (SAT–SUN)', enDate: 'Any Weekend until 31 Oct 2026', enTag: 'Weekend Prime' }
    },
    defaultDate: 'any-day-pass',
    banner: {
      en: './images/dino_world_singapore_banner_en.jpg'
    },
    tiersConfig: {
      vip: {
        id: 'vip',
        color: '#fbc61c',
        popular: true,
        options: {
          adult: { standardPrice: 36.00, price: 18.00 },
          kid: { standardPrice: 28.00, price: 14.00 }
        }
      }
    }
  },

  my: {
    id: 'my',
    name: 'Malaysia',
    currencyCode: 'MYR',
    currencySymbol: { en: 'RM' },
    phonePrefix: '+60',
    phonePlaceholder: '123456789',
    seatPrefix: 'MY',
    defaultLang: 'en',
    supportedLangs: ['en'],
    merchantName: 'Dino World Malaysia',
    domainName: 'mydynoworld.live',
    venue: {
      en: 'Malaysia International Trade and Exhibition Centre (MITEC) Kuala Lumpur (Halls 1 & 2)'
    },
    datesText: {
      en: 'Open Daily: 10 September – 31 October 2026 | Valid Any Day (09:00 AM – 09:00 PM)'
    },
    validUntilDate: {
      en: '31 October 2026'
    },
    isOpenPass: true,
    dates: {
      'any-day-pass': { enDay: 'OPEN PASS • ANY DATE', enDate: 'Valid Any Day until 31 Oct 2026', enTag: 'Best Value • 100% Flexible' },
      'weekday-pass': { enDay: 'WEEKDAY PASS (MON–FRI)', enDate: 'Any Weekday until 31 Oct 2026', enTag: 'Calm Visit • Less Crowded' },
      'weekend-pass': { enDay: 'WEEKEND PASS (SAT–SUN)', enDate: 'Any Weekend until 31 Oct 2026', enTag: 'Weekend Prime' }
    },
    defaultDate: 'any-day-pass',
    banner: {
      en: './images/dino_world_malaysia_banner_en.jpg'
    },
    tiersConfig: {
      vip: {
        id: 'vip',
        color: '#fbc61c',
        popular: true,
        options: {
          adult: { standardPrice: 70.00, price: 35.00 },
          kid: { standardPrice: 56.00, price: 28.00 }
        }
      }
    }
  }
};

export const getCurrentGeo = () => {
  if (typeof window !== 'undefined' && window.DINO_GEO && GEOS[window.DINO_GEO.toLowerCase()]) {
    return window.DINO_GEO.toLowerCase();
  }

  if (typeof window !== 'undefined' && window.location) {
    const searchParams = new URLSearchParams(window.location.search);
    const geoParam = searchParams.get('geo') || searchParams.get('g');
    if (geoParam && GEOS[geoParam.toLowerCase()]) {
      const clean = geoParam.toLowerCase();
      localStorage.setItem('dino_geo', clean);
      return clean;
    }

    if (window.location.hash && window.location.hash.includes('?')) {
      const hashQuery = window.location.hash.split('?')[1];
      const hashParams = new URLSearchParams(hashQuery);
      const hashGeo = hashParams.get('geo') || hashParams.get('g');
      if (hashGeo && GEOS[hashGeo.toLowerCase()]) {
        const clean = hashGeo.toLowerCase();
        localStorage.setItem('dino_geo', clean);
        return clean;
      }
    }

    if (window.location.hostname) {
      const host = window.location.hostname.toLowerCase();
      if (host.includes('dynoworldph') || host.includes('phdynoworld') || host.includes('philippines')) return 'ph';
      if (host.includes('dynoworldsg') || host.includes('sgdynoworld') || host.includes('singapore')) return 'sg';
      if (host.includes('dynoworldmy') || host.includes('mydynoworld') || host.includes('malaysia')) return 'my';
      if (host.includes('dynoworldhk') || host.includes('hongkong')) return 'hk';
      if (host.includes('dynoworldkw') || host.includes('kuwait')) return 'kw';
      if (host.includes('dynoworldom') || host.includes('oman')) return 'om';
      if (host.includes('dynoworldqa') || host.includes('qatar')) return 'qa';
    }

    const path = window.location.pathname.toLowerCase();
    if (path.includes('philippines') || path.includes('/ph')) return 'ph';
    if (path.includes('singapore') || path.includes('/sg')) return 'sg';
    if (path.includes('malaysia') || path.includes('/my')) return 'my';
    if (path.includes('oman') || path.includes('/om')) return 'om';
    if (path.includes('kuwait') || path.includes('/kw')) return 'kw';
    if (path.includes('hongkong') || path.includes('/hk')) return 'hk';
    if (path.includes('qatar') || path.includes('/qa')) return 'qa';
  }

  if (typeof localStorage !== 'undefined') {
    const cached = localStorage.getItem('dino_geo');
    if (cached && GEOS[cached.toLowerCase()]) {
      return cached.toLowerCase();
    }
  }

  return 'qa';
};
